import React from 'react'
import '../App.css'
import Bodyordenesreport from './bodyordenesreport'
export class Bodyappordenesreportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyordenesreport/>
            </div>    
        );
    }
}